/** Used to match template delimiters. */
var reEvaluate = /<%([\s\S]+?)%>/g;

module.exports = reEvaluate;



//////////////////
// WEBPACK FOOTER
// ../~/lodash/_reEvaluate.js
// module id = 1026
// module chunks = 0